import script from "./ReceiptsPaymentsReportTableShort.vue?vue&type=script&setup=true&lang=js"
export * from "./ReceiptsPaymentsReportTableShort.vue?vue&type=script&setup=true&lang=js"

import "./ReceiptsPaymentsReportTableShort.vue?vue&type=style&index=0&id=c8bff5b6&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8bff5b6"]])

export default __exports__